import DateRangeColumnFilter from 'components/atoms/date-range-column-filter'
import RowButton from 'components/atoms/row-button'
import SelectTableFilter from 'components/atoms/select-table-filter'
import ActiveBadge from 'domains/voucher/atoms/active-badge'
import { VoucherShowOnCheckoutBadge } from 'domains/voucher'
import React from 'react'
import TimeUtil from 'utils/time-util'


const BOOLEAN_STATUS = Object.freeze({
  'Yes' : true,
  'No'  : false
})

const voucherListColumns = (handleSelectRow) => {

  // Custom Filter
  // Used to modify the filter in specific columns

  // eslint-disable-next-line react/prop-types
  const IsActiveFilter = ({ column }) => {
    const options = Object.keys(BOOLEAN_STATUS).map((key) => (
      {
        label : key,
        value : BOOLEAN_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  // eslint-disable-next-line react/prop-types
  const ShowOnCheckoutFilter = ({ column }) => {
    const options = Object.keys(BOOLEAN_STATUS).map((key) => (
      {
        label : key,
        value : BOOLEAN_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  const VoucherCell = (row) => row.cell.value.length > 0 ? (row.cell.value.length > 1 ? row.cell.value[0].code : `${row.cell.value[0].code}...`) : '-'


  const DateCell = (row) => TimeUtil.format(row.cell.value)

  const IsActiveCell       = (row) => <ActiveBadge isActive={ row.cell.value } />
  const ShowOnCheckoutCell = (row) => <VoucherShowOnCheckoutBadge showOnCheckout={ row.cell.value } />

  // eslint-disable-next-line react/prop-types
  const ActionCell = ({ cell: { row } }) => (
    <RowButton
      // eslint-disable-next-line react/prop-types
      data={ row.original }
      color='primary'
      onClick={ handleSelectRow }
      text='View'
    />
  )


  return (
    [
      {
        Header         : 'ID',
        accessor       : 'id',
        disableFilters : true
      },
      {
        Header   : 'Name',
        accessor : 'name'
      },
      {
        Header   : 'Voucher Code',
        accessor : 'vouchers',
        id       : 'voucher_code',
        Cell     : VoucherCell
      },
      {
        Header   : 'Date Start',
        accessor : 'from_date',
        Cell     : DateCell,
        Filter   : DateRangeColumnFilter
      },
      {
        Header   : 'Date Expire',
        accessor : 'to_date',
        Cell     : DateCell,
        Filter   : DateRangeColumnFilter
      },
      {
        Header   : 'Is Active?',
        accessor : 'is_active',
        Cell     : IsActiveCell,
        Filter   : IsActiveFilter
      },
      {
        Header   : 'Show on Checkout',
        accessor : 'show_on_checkout',
        Cell     : ShowOnCheckoutCell,
        Filter   : ShowOnCheckoutFilter
      },
      {
        Header         : 'Used',
        accessor       : 'times_used',
        disableFilters : true
      },
      {
        Header         : 'Action',
        id             : 'action',
        Cell           : ActionCell,
        disableFilters : true
      }
    ]
  )

}

export default voucherListColumns
